<template>
	<div>
		<el-table border :data="tableData" style="width: 100%" ref="filterTable">
            <el-table-column type="index" label="序号" width="150"> </el-table-column>
            <el-table-column property="time" label="时间" width="250"></el-table-column>            
            <el-table-column property="msg" label="信息" width="300"></el-table-column>
            <el-table-column prop="tag" label="等级" width="100" :filters="[
                       { text: '警告', value: '警告' }, 
                       { text: '信息', value: '信息' },
                       { text: '调试', value: '调试' }, 
                       { text: '错误', value: '错误' }]"
            :filter-method="filterTag"
            filter-placement="bottom-end">
                <template slot-scope="scope">
                    <el-tag
                    :type="scope.row.tag === '警告' ? 'primary' : 'success'"
                    disable-transitions>{{scope.row.tag}}</el-tag>
                </template>
            </el-table-column>
		</el-table>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableData: [
					{
						time: 'yyyy-mm-dd;hh:mm',
						msg: '',
						tag: '信息',
					},{
						time: 'yyyy-mm-dd;hh:mm',
						msg: '',
						tag: '警告',
					},
				],
			}
		},
		methods: {
            filterTag(value, row) {
                return row.tag === value;
            },
		},
	}
</script>

<style></style>
